import { Injectable, EventEmitter } from "@angular/core";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LoadingModalComponent } from './loading-modal.component';

@Injectable({
    providedIn: 'root'
})
export class LoadingModalService {
    public countLoading: number;
    private bsModalRef: BsModalRef;

    public isShown: boolean

    public show: EventEmitter<EventEmitter<boolean>>;
    public hide: EventEmitter<void>;

    constructor(
        private modalService: BsModalService
    ) {
        this.countLoading = 0;
        this.show = new EventEmitter<EventEmitter<boolean>>();
        this.hide = new EventEmitter<void>();
    }

    decrementLoading() {
        this.countLoading--;
        if (this.countLoading < 0) {
            this.countLoading = 0;
        }

        if (this.countLoading == 0) {
            this.isShown = false;
            this.bsModalRef.hide();
        }
    }

    incrementLoading() {
        if (this.countLoading === 0) {
            this.bsModalRef = this.modalService.show(LoadingModalComponent, { backdrop: 'static', keyboard: false, class: "modal-loading" });
            this.isShown = true;
        }
        this.countLoading++;
    }

    hideLoading() {
        this.countLoading = 0;
        this.isShown = false;
        this.hide.next();
    }
}